import { GoogleLogin, CredentialResponse } from '@react-oauth/google';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

export function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleSuccess = async (credentialResponse: CredentialResponse) => {
        if (!credentialResponse.credential) {
            setError('登入失敗：未收到憑證');
            return;
        }

        setIsLoading(true);
        setError(null);

        try {
            await login(credentialResponse.credential);
            navigate('/');
        } catch (err: any) {
            console.error('Login failed:', err);
            setError(err.message || '登入失敗，請稍後再試');
        } finally {
            setIsLoading(false);
        }
    };

    const handleError = () => {
        setError('Google 登入失敗');
    };

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        }}>
            <div style={{
                background: 'white',
                padding: '3rem',
                borderRadius: '16px',
                boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
                maxWidth: '400px',
                width: '100%',
                textAlign: 'center'
            }}>
                <h1 style={{
                    fontSize: '2rem',
                    fontWeight: 700,
                    marginBottom: '0.5rem',
                    color: '#1a202c'
                }}>
                    GAD Alchemist
                </h1>
                <p style={{
                    color: '#718096',
                    marginBottom: '2rem'
                }}>
                    廣告文案生成系統
                </p>

                {error && (
                    <div style={{
                        background: '#fed7d7',
                        color: '#c53030',
                        padding: '1rem',
                        borderRadius: '8px',
                        marginBottom: '1.5rem',
                        fontSize: '0.9rem'
                    }}>
                        {error}
                    </div>
                )}

                {isLoading ? (
                    <div style={{
                        padding: '2rem',
                        color: '#718096'
                    }}>
                        登入中...
                    </div>
                ) : (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        <GoogleLogin
                            onSuccess={handleSuccess}
                            onError={handleError}
                            theme="filled_blue"
                            size="large"
                            text="signin_with"
                            shape="rectangular"
                        />
                    </div>
                )}

                <p style={{
                    marginTop: '2rem',
                    fontSize: '0.85rem',
                    color: '#a0aec0'
                }}>
                    僅限授權使用者登入
                </p>
            </div>
        </div>
    );
}
